import { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { Link } from 'react-router-dom';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import Loader from "react-js-loader";
import { Chart } from 'primereact/chart';
import { Carousel } from 'primereact/carousel';
import { Skeleton } from 'primereact/skeleton';
import AnnouncementModal from './AnnouncementModal';
import { useNavigate } from 'react-router-dom';
import MobileUse from '../../modules/mobileUtilities/MobileUse'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  return data !== null ? JSON.parse(data) : null;
};

const DashboardPage = () => {

  const navigate = useNavigate();
  const isMobileDevice = MobileUse();

  const OrderChartRef = useRef(null);
  const OrderChartInstanceRef = useRef(null); // Reference to the chart instance

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [chartData2, setChartData2] = useState({});
    const [chartOptions2, setChartOptions2] = useState({});

  const [orderTotalAmount, setOrderTotalAmount] = useState([10000, 25000, 5000, 35000, 18000]);
  const [orderTotalCommission, setOrderTotalCommission] = useState([100, 250, 25, 350, 280]);

  const [apiData, setApiData] = useState([]);
  const [commitData, setCommitData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [trackingData, setTrackingData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [dueBalance, setDueBalance] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [dealLoading, setDealLoading] = useState(false);
  const [commitLoading, setCommitLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const localData = getLocalData();

  const API_URL = process.env.REACT_APP_API_URL;
  const DEALS_URL = `${API_URL}/dashboard/deals`;
  const GET_COMMIT_URL = `${API_URL}/dashboard/commitments`;
  const ORDERS = `${API_URL}/user/dashboard/orders`;
  const USER_PAYMENTS = `${API_URL}/user/dashboard/payments`;
  const DUE_BALANCE = `${API_URL}/user/dashboard/due-balance`;
  const GET_DASHBOARD_DATA = `${API_URL}/user/dashboard`;
  const GET_DASHBOARD_TRACKINGS = `${API_URL}/dashboard/tracking/details`;
  

  const getCommitments = async () => {
    setCommitLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    await axios.get(GET_COMMIT_URL, config)
      .then((response) => {
        setCommitData(response.data.data);
        setCommitLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setCommitLoading(false);
      });
  };

  // const getOrderData = async () => {
  //   setOrderLoading(true);
  //   const config = {
  //     headers: { Authorization: `Bearer ${localData.api_token}` }
  //   };
  //   await axios.get(ORDERS, config)
  //     .then((response) => {
  //       setOrderData(response.data.data);
  //       setOrderLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setOrderLoading(false);
  //     });
  // };

  const getTrackingData = async () => {
    setTrackingLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    await axios.get(GET_DASHBOARD_TRACKINGS, config)
      .then((response) => {
        setTrackingData(response.data.data);
        setTrackingLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setTrackingLoading(false);
      });
  };

  const getPayementsData = async () => {
    setPaymentLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    await axios.get(USER_PAYMENTS, config)
      .then((response) => {
        setPaymentData(response.data.data);
        setPaymentLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setPaymentLoading(false);
      });
  };

  const getDueBalanceData = async () => {
    setPaymentLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    await axios.get(DUE_BALANCE, config)
      .then((response) => {
        setDueBalance(response.data.data);
        setPaymentLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setPaymentLoading(false);
      });
  };

  const getDashboardData = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    await axios.get(GET_DASHBOARD_DATA, config)
      .then((response) => {
        setDashboardData(response.data.data[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getApiData = async () => {
    setDealLoading(true);
    try {
      await axios.get(DEALS_URL)
        .then((res) => {
          setApiData(res.data.data);
          setDealLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setDealLoading(false);
        });
    } catch (error) {
      console.error(error);
      setDealLoading(false);
    }
  };

  const getDueDate = (createdAt) => {
    const date = new Date(createdAt);
    date.setDate(date.getDate() + 15); 
    const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`;
    return formattedDate;
};

  useEffect(()=>{
    if (dashboardData?.orderTotalAmount && dashboardData?.orderTotalCommision) {
      setOrderTotalAmount(dashboardData?.orderTotalAmount);
      setOrderTotalCommission(dashboardData?.orderTotalCommision);
    }
  },[dashboardData])


  useEffect(() => {
    getDashboardData();
    getTrackingData();
    getCommitments();
    // getOrderData();
    getPayementsData();
    getDueBalanceData();
    getApiData();
  }, []);


  const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 5,
            numScroll: 1
        },
        {
            breakpoint: '1199px',
            numVisible: 4,
            numScroll: 1
        },
        {
            breakpoint: '767px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    const formatDate = (myDate) =>{
      const date = new Date(myDate);
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
    
      return `${month}-${day}-${year}`;
    }

    const dealCardTemplate = (val)=>{
      return(
        <>
        {dealLoading ? (
          <Skeleton height="250px" className="mb-2"></Skeleton>
        ) : (
          <div className="card shadow bg-gray-300 mx-3"style={{height:250}}>
                <div className="card-body  position-relative">
                  <div className="label-wrap position-absolute top-0 end-0 mt-3 me-2">
                      {getDealStatus(val)}
                    </div>
                  <div className="mb-3 w-100 bg-white d-flex align-items-center justify-content-center" style={{borderRadius:10}}>
                    
                    <img src={val?.default_color?.image} alt="" className="shadow-2" style={{width:'auto',height:75,margin:10}} />
                </div>
                <div>
                    <a href='#' onClick={()=> navigate('/deals',{ state:{openDealDetailModal:true,deal:val}})}>
                      <h6 className="mb-1">{truncateDealName(val.name)}</h6>
                      </a>
                    <h6 className="mt-0 mb-3">
                      <CurrencyFormat
                          decimalScale={2}
                          value={itemPrice(val).orderPrice}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                    </h6>
                    <span>Expires: {formatDate(val.expires)}</span>
                </div>
                </div>
            </div>
        )}
        </>
      )
      return(
        <>
        
        </>
      );
    }

  const itemPrice = (val) => {
    var data = {};
    if (val.commission_status == 1) {
      const commission = parseFloat(val.default_color?.commission);
      data = {
        status: 1,
        orderPrice: (parseFloat(val.default_color?.price) + commission).toFixed(2),
        actualPrice: parseFloat(val.default_color?.price).toFixed(2),
        commission: commission,
      }
    } else if (val.retail == 1) {
      data = {
        status: 0,
        orderPrice: parseFloat(val.default_color?.price).toFixed(2),
        actualPrice: parseFloat(val.default_color?.price).toFixed(2),
        commission: 0,
      }
    } else if (val.below_cost == 1) {
      data = {
        status: 1,
        orderPrice: parseFloat(val.default_color?.price).toFixed(2),
        actualPrice: parseFloat(val.default_color?.commission).toFixed(2),
        commission: 0,
      }
    }

    return data;
  };

  useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');

        const months = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const currentMonth = new Date().getMonth();
        const monthLabels = [];
        for (let i = -4; i <= 1; i++) {
          const monthIndex = (currentMonth + i + 12) % 12;
          monthLabels.push(months[monthIndex]);
        }

        const dataLabels = monthLabels;

        const data = {
            labels: dataLabels,
            datasets: [
                {
                    label: 'Total Spent',
                    data: orderTotalAmount,
                    fill: true,
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    tension: 0.4,
                    backgroundColor: 'rgba(38, 161, 255, 0.2)'
                },
            ]
        };

        const data2 = {
            labels: dataLabels,
            datasets: [
                {
                    label: 'Commission Earned',
                    data: orderTotalCommission,
                    fill: true,
                    borderColor: documentStyle.getPropertyValue('--orange-500'),
                    tension: 0.4,
                    backgroundColor: 'rgba(231, 153, 18, 0.2)'
                }
            ]
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        display:false
                    }
                },
                y: {
                    min: 0,
                    max: 100000,
                    ticks: {
                      callback: (value) =>
                      `$${Number(value).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`,
                        color: textColorSecondary,
                        stepSize: 25000
                    },
                    grid: {
                        display:false
                    }
                }
            },
            plugins: {
            tooltip: {
              callbacks: {
                label: (context) =>
                  `Spent: $${context.parsed.y.toLocaleString()}`
              }
            }
          }
        };
        const options2 = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        display:false
                    }
                },
                y: {
                    min: 0,
                    max: 1000,
                    ticks: {
                      callback: (value) =>
                      `$${Number(value).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`,
                        color: textColorSecondary,
                        stepSize: 250
                    },
                    grid: {
                        display:false
                    }
                }
            },
            plugins: {
            tooltip: {
              callbacks: {
                label: (context) =>
                  `Commission: $${context.parsed.y.toLocaleString()}`
              }
            }
          }
        };

        setChartData(data);
        setChartOptions(options);
        setChartData2(data2);
        setChartOptions2(options2);

    }, [orderTotalAmount, orderTotalCommission]);

  const truncateString = (str) =>{
    const maxLength = 15;
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '...';
    } else {
      return str;
    }
  }
  const truncateDealName = (str) =>{
    const maxLength = 35;
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '...';
    } else {
      return str;
    }
  }

  // const getOrderStatus = (val) =>{
  //   if(val.status == 0){
  //     return(
  //     <span className='badge badge-light-success fs-8 fw-bold success_active'>
  //       Delivered
  //     </span>
  //     )
  //   }
  //   if(val.commit_status == 1 && val.status == 1){
  //     return(
  //       <span className='badge badge-light-danger fs-8 fw-bold danger_active'>
  //           Confirmed
  //         </span>
          
  //     )
  //   }else{
  //     if(val.status == 1){
  //       return(
  //         <span className='badge badge-light-info fs-8 fw-bold info_active'>
  //         Shipped
  //       </span>
  //       )
  //     }
  //   }
    
  // }



  const getDealStatus = (item) => {
    if (item.status == 2) {
      return (
        <div className='mb-3 badge badge-warning d-flex align-items-center justify-content-center' style={{marginLeft: '-15px',width:80}}><span>Expired</span></div>
      )
    }
    if (item.status == 1 && item.deal_stock == 'true') {
      return (
        <div className='mb-3 badge badge-info d-flex align-items-center justify-content-center'style={{marginLeft: '-15px',width:80}}><span>In Stock</span></div>
      )
    }
    if (item.deal_stock == 'false' && item.status != 2) {
      return (
        <div className='mb-3 badge badge-danger d-flex align-items-center justify-content-center' style={{ marginLeft: '-15px',width:80 }}><span>Commit Full</span></div>
      )
    }
  }

  
  return (
    <>
    <AnnouncementModal/>
      <div>
        {/* NEW DESIGN */}
         <style>
        {`
          .stats-card {
            padding: 5px;
            border-radius: 20px;
          }
          .stats-card .secondary-body{
            padding: 10px 10px 20px 10px;
          }  

          .stats-card .icon{
            color:white;
            font-size:20px;
          }

          .stats-card .amount{
            color:white;
          }

          .stats-card .title {
            color: white;
          }

          .chart-card{
          border-radius:20px;
          }

          .banner-card{
            height:225px;
            border-radius:20px;
          }

          .commit-counters .item{
          display:flex;
          flex-direction:column;
          align-items:center;
          margin-bottom:10px;
          }
          
          .commit-counters .icon-wrap{
            border-radius:50%;
            padding:5px;
            display:flex;
            align-items:center;
            justify-content:center;
            background-color:#4168d1;
            width:50px;
            height:50px;
          }

          .commit-counters .title{
            color:#212a49;
            } 
          .commit-counters .value{
            color:#4168d1;
            } 

            .commitment-card{
            border-radius:20px 20px 10px 10px;
            padding:0 0 10px 0;
            }

            .commitment-card .card-body{
            display:flex;
            flex-direction:column;
            align-items:center;
            padding:5px;
            }

            .commitment-card .label{
                height:40px;
                background-color:grey;
                border-radius:20px 20px 0 0;
                display:flex;
                align-items:center;
                justify-content:center;
            }

        `}
      </style>
        <div className="row ">
          <div className="col-lg-8 col-sm-12">
              <div className="banner-card bg-grey mb-5" 
              style={{
                backgroundImage: 'url("https://makemoneyormiles.com/media/images/banner-dashboard.png")',
                // backgroundImage: 'url("https://makemoneyormiles.com/media/images/bigdealdays-banner-20263.png")',
                backgroundSize: 'contain',
                // backgroundPosition: 'center',
                // backgroundRepeat: 'no-repeat',
                // backgroundColor:'#163559',
                height:250,
                backgroundColor:'#f1952f'
              }}
              >
                <div className="container" style={{padding:'20px 30px'}}>
                  <h2 className='text-gray-900'>Welcome Back</h2>
                  <h1 className='' style={{color:'#f1952f'}}>{localData.first_name} {localData.last_name}</h1>
                  <h5 className='mt-3' style={{color:'#bd6c10ff'}}>Stronger Together, Better Deals Forever</h5>
                  <h6 className='' style={{color:'#6f3f08ff'}}>The community-driven way to save and grow.</h6>
                  <Link to={'/deals'}>
                  <button type='button' className='deal-btn btn btn-warning mt-2 ml-5'
                     style={{background: 'linear-gradient(90deg, #000046 0%, #1cb5e0 100%)'}}
                  >
                  Explore Deals
                  </button>
                  </Link>
                </div>
                {/* <div className="container text-end" style={{padding:'20px 30px'}}>
                  <h2 className='text-white'>Welcome Back</h2>
                  <h1 className='' style={{color:'#ffffffff'}}>{localData.first_name} {localData.last_name}</h1>
                </div> */}
              </div>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="card shadow chart-card">
                    <div className="card-body">
                      <Chart type="line" data={chartData} options={chartOptions}  style={{height:'200px'}} />
                    </div>
                </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="card shadow chart-card">
                    <div className="card-body">
                      <Chart type="line" data={chartData2} options={chartOptions2} style={{height:'200px'}} />
                    </div>
                </div>
                </div>
              </div>
          </div>
          <div className="col-lg-4 col-sm-12">
              <div className="bg-gray-200 px-5 py-5" style={{borderRadius:'20px'}}>
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="card stats-card mb-3" style={{background:'#3cc9eb'}}>
                      <div className="card-body primary-body">
                        <div className="row">
                          <div className="col-3">
                              <i class="bi bi-wallet icon"></i>
                          </div>
                          <div className="col-9 text-end">
                              <h3 className='amount'>
                            {dashboardData.currentBalance !== '' ? (
                              <CurrencyFormat
                                decimalScale={2}
                                value={parseFloat(dashboardData.currentBalance).toFixed(2)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                              />
                            ) : (
                              '$0.00'
                            )}
                          </h3>
                          </div>
                          </div>
                          <h6 className="title mt-3">Total Balance</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6">
                    <div className="card stats-card mb-3" style={{background:'#f7c426'}}>
                      <div className="card-body secondary-body">
                        <div className="row">
                          <div className="col-12 text-start">
                              <i class="bi bi-box2-heart icon"></i>
                          </div>
                          <div className="col-12 text-center">
                              <h1 className='amount' style={{fontSize:'3rem'}}>
                            {dashboardData?.tracking}
                          </h1>
                          </div>
                          </div>
                          <div className="col-12 text-center d-flex flex-column">
                              {/* <i class="bi bi-wallet"></i> */}
                              <h6 className="title mt-3">On Tracking</h6>
                          </div>
                          
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6">
                    <div className="card stats-card mb-3" style={{background:'#f1952f'}}>
                      <div className="card-body secondary-body">
                        <div className="row">
                          <div className="col-12 text-start">
                              <i class="bi bi-bookmark-heart icon"></i>
                          </div>
                          <div className="col-12 text-center">
                              <h1 className='amount' style={{fontSize:'3rem'}}>
                            {dashboardData?.activeDeals}
                          </h1>
                          </div>
                          </div>
                          <div className="col-12 text-center d-flex flex-column">
                          <h6 className="title mt-3">Active Deals</h6>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="card stats-card mb-3" style={{background:'#4b34a8'}}>
                      <div className="card-body primary-body">
                        <div className="row">
                          <div className="col-3">
                              <i class="bi bi-cash-coin icon"></i>
                          </div>
                          <div className="col-9 text-end">
                              <h3 className='amount'>
                            <CurrencyFormat
                          decimalScale={2}
                          value={parseFloat(dashboardData?.withdrawPaid)?.toFixed(2)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                          </h3>
                          </div>
                          </div>
                          <h6 className="title mt-3">Total Withdrawn</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-12 col-sm-12">
            <Carousel value={apiData} numScroll={1} numVisible={5} responsiveOptions={responsiveOptions} autoplayInterval={(!isMobileDevice) ? 5000 : 2000} itemTemplate={dealCardTemplate} />
          </div>
        </div>
        <div className="row mt-5 commit-counters">
          <div className="col-lg-8 col-sm-12">
            <div className="d-flex mt-5">
              <i className="fas fa-handshake me-2" style={{ fontSize: '1.5rem' }}></i>
              <h4>Recent Commitments</h4>
            </div>
            {/* <div className="border-bottom my-2"></div> */}
            {commitLoading ? (
              <div className='row'>
                <div className="row">
                  {Array.from({ length: 12 }).map((_, index) => (
                    <div className="col-lg-3 mb-3" key={index}>
                      <Skeleton height="110px" style={{borderRadius:'20px 20px 0 0'}} />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <>
            {commitData.length === 0 && (
              <div className='fs-5 fw-semibold text-gray-600'>
                <div className='text-center mt-5'>
                  <h4>No Pending Commits..</h4>
                  <Link
                    to='/deals'
                    className='btn btn-sm btn-primary'
                    style={{ backgroundColor: '#ffd70dff',borderRadius:'25px' }}
                  >
                    <span>Commit Now</span>
                  </Link>
                </div>
              </div>
            )}
            {commitData.length !== 0 && (
            <div className="row">
              {commitData.map((val,index)=>{
                return(
                  <div className="col-lg-3">
                    <div className="card shadow commitment-card mb-3">
                          {val.status == 0 && (
                            <div className="label bg-light-success">
                            <span className='fs-6 fw-bold'>Received</span>
                            </div>
                          )}
                          {val.status == 1 && (
                            <div className="label bg-light-warning">
                            <span className='fs-6 fw-bold '>Pending</span>
                            </div>
                          )}
                          {val.status == 2 && (
                            
                            <div className="label bg-light-success">
                            <span className='fs-6 fw-bold '>
                              Active
                            </span>
                            </div>
                          )}
                          {val.status == 3 && (
                            <div className="label bg-light-danger">
                            <span className='fs-6 fw-bold'>
                              Expired
                            </span>
                            </div>
                          )}
                          {val.status == 4 && (
                            <div className="label bg-light-warning">
                            <span className='fs-6 fw-bold '>
                              In prpgress
                            </span>
                            </div>
                          )}
                          {val.status == 5 && (
                            <div className="label bg-light-warning">
                            <span className='fs-6 fw-bold '>
                              Return Pending
                            </span>
                            </div>
                          )}
                          {val.status == 6 && (
                            <div className="label bg-light-info">
                            <span className='fs-6 p-3 fw-bold'>
                              Return Active
                            </span>
                            </div>
                          )}
                          {val.status == 7 && (
                            <div className="label bg-light-success">
                            <span className='fs-6 fw-bold '>
                              Return Completed
                            </span>
                            </div>
                          )}
                          <div className="card-body">
                          <div className='text-gray-800 text-hover-primary fw-bold'>
                          {val.commitment_no}
                        </div>
                        <div className="img-wrap">
                          <img
                            src={val.deal_image?.image}
                            // src={'https://erp.makemoneyormiles.com/storage/deals/832124.jpg'}
                            className='img-sm ms-n1 me-1'
                            alt='deal-image'
                          />
                        </div>
                        
                        <div className='d-flex flex-stack'>
                          <span className='text-gray-400 fw-bold me-2'>
                            Qty:
                            <span className='text-gray-800 text-hover-primary fw-bold'>
                              {' '}
                              {val.commited_qty}
                            </span>
                          </span>
                          <span className='text-gray-400 fw-bold'>
                            Fullfill Qty:
                            <span className='text-gray-800 text-hover-primary fw-bold'>
                              {' '}
                              {val.fullfill_qty}
                            </span>
                          </span>
                        </div>
                        </div>
                    </div>
                  </div>
                )
              })}
            </div>
            )}
            </>
            )}
          </div>
          <div className="col-lg-4 col-sm-12">
              <div className="bg-gray-200 px-5 py-5" style={{borderRadius:'20px'}}>
                <div className="d-flex">
                    <i className="fas fa-handshake me-2" style={{ fontSize: '1.5rem' }}></i>
                    <h4>Commitments</h4>
                  </div>
                <div className="row">
                  <div className="col-4">
                    <div className="item">
                      <div className="icon-wrap">
                      <i className="bi bi-clipboard-data icon" style={{fontSize:20,color:'white'}}></i>
                    </div>
                    <h5 className="title">
                      Commits
                    </h5>
                    <h4 className="value">
                      {dashboardData?.totalCommit}
                    </h4>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="item">
                      <div className="icon-wrap">
                      <i className="bi bi-check-circle-fill icon" style={{fontSize:20,color:'white'}}></i>
                    </div>
                    <h5 className="title">
                      Archived
                    </h5>
                    <h4 className="value">
                      {dashboardData?.archivedCommit}
                    </h4>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="item">
                      <div className="icon-wrap">
                      <i className="bi bi-clock-history icon" style={{fontSize:20,color:'white'}}></i>
                    </div>
                    <h5 className="title">
                      Pending
                    </h5>
                    <h4 className="value">
                      {dashboardData?.pendingCommit}
                    </h4>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="item">
                      <div className="icon-wrap">
                      <i className="bi bi-gear-fill icon" style={{fontSize:20,color:'white'}}></i>
                    </div>
                    <h5 className="title">
                      Processing
                    </h5>
                    <h4 className="value">
                      {dashboardData?.inProcessCommit}
                    </h4>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="item">
                      <div className="icon-wrap">
                      <i className="bi bi-arrow-counterclockwise icon" style={{fontSize:20,color:'white'}}></i>
                    </div>
                    <h5 className="title">
                      Return
                    </h5>
                    <h4 className="value">
                      {dashboardData?.returnCommit}
                    </h4>
                    </div>
                  </div>
                </div>
                <div className="my-3" style={{borderBottom:'5px solid grey'}}></div>
                <div className="d-flex my-2">
                    <i className="fas fa-money-bill-wave me-2" style={{ fontSize: '1.5rem' }}></i>
                    <h4>Processing Payments & Balance</h4>
                  </div>
                {paymentLoading ? (
                <>
                <Skeleton height="2rem" className="mb-2"></Skeleton>
                <Skeleton height="1rem" className="mb-2"></Skeleton>
                </>
              ) : (
                <div className='card-body pt-0 table_container'>
                  {paymentData.length === 0 && (
                    <div className='fs-5 fw-semibold text-gray-600'>
                      <p>No Pending Payments..</p>
                    </div>
                  )}
                  {paymentData.map((val, index) => {
                    return (
                      <>
                        <div className='m-0'>
                          <div className='d-flex align-items-sm-center mb-5'>
                            <div className='symbol symbol-45px me-4'>
                              <span className='symbol-label bg-info'>
                                <i className='fa-solid fa-receipt text-inverse-primary fs-1'></i>
                              </span>
                            </div>
                            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                              <div className='flex-grow-1 me-2'>
                                <span className='text-gray-700 fw-bold d-block fs-4'>
                                  ${val.price}
                                </span>
                                <span className='text-gray-400 fw-bold d-block fs-6'>
                                  Due: {getDueDate(val.created_at)}
                                </span>
                              </div>
                              <span className='fw-bold my-2'>
                                  <span className='badge badge-light-info fs-8 fw-bold info_active'>
                                    Processing
                                  </span>
                              </span>
                            </div>
                          </div>
                        </div>
                         
                      </>
                    )
                  })}
                  <div className='separator separator-dashed my-6' />
                  {dueBalance ?
                      <>
                      <div className='fs-5 fw-semibold text-gray-600'>
                      <p>Due Balance</p>
                    </div>
                        <div className='m-0'>
                          <div className='d-flex align-items-sm-center mb-5'>
                            <div className='symbol symbol-45px me-4'>
                              <span className='symbol-label bg-warning'>
                                <i className='fa-solid fa-hourglass-half text-inverse-primary fs-1'></i>
                              </span>
                            </div>
                            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                              <div className='flex-grow-1 me-2'>
                                <span className='text-gray-700 fw-bold d-block fs-4'>
                                  ${dueBalance.dueAmount}
                                </span>
                              </div>
                              <span className='fw-bold my-2'>
                                {dueBalance.status == 1 && (
                                  <span className='badge badge-light-warning fs-8 fw-bold info_active'>
                                    Due Balance
                                  </span>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* <div className='separator separator-dashed my-6' /> */}
                      </>
                  :
                  <></>
                  }
                </div>
              )}
          </div>
        </div>
        </div>


      </div>

      <div className='mt-10'>
        <div className='row'>
          <div className='col-sm-12 col-md-12'>
            <div className='card-flush'>
              <div className='d-flex justify-content-between  px-5 align-item-senter'>
                <div className="d-flex">
                    <i className="fas fa-shipping-fast me-2" style={{ fontSize: '1.5rem' }}></i>
                    <h4>Recent Trackings</h4>
                  </div>
                {trackingData.length !== 0 && (
                  <div className='text-center'>
                    <Link
                      to='/tracking'
                      className='btn btn-sm btn-primary mb-3'
                      style={{ backgroundColor: '#4168d1',borderRadius:'25px' }}
                    >
                      <span>View More&nbsp;&nbsp;<i className="fas fa-chevron-circle-right text-white"></i></span>
                    </Link>
                  </div>
                )}
              </div>
              {trackingLoading ? (
                <div className='item'>
                  <Loader type='spinner-cub' bgColor={'#4168d1'} size={50} />
                </div>
              ) : (
                <div className='pt-0'>
                  {trackingData.length === 0 && (
                    <div className='fs-5 fw-semibold text-gray-600'>
                      <p>No Trackings Available.</p>
                    </div>
                  )}
                  <div className="row">
                  {trackingData.map((val, index) => {
                    return (
                      <>
                        <div className="col-lg-6 col-sm-12">
                          <div className="card shadow mb-3" style={{borderRadius:'20px'}}>
                            <div className='card-body m-0'>
                          <div className='d-flex align-items-sm-center mb-5'>
                            <div className='symbol symbol-45px me-4'>
                              <span className='symbol-label bg-primary'>
                                <i className='ki-duotone ki-truck text-inverse-primary fs-1'>
                                  <span className='path1' />
                                  <span className='path2' />
                                  <span className='path3' />
                                  <span className='path4' />
                                  <span className='path5' />
                                </i>
                              </span>
                            </div>
                            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                              <div className='flex-grow-1 me-2'>
                                <span className='text-gray-700 fw-bold d-block fs-4'>
                                  {val.tracking_no}
                                </span>
                              </div>
                              <span className='fw-bold my-2'>
                                {val.status == 0 && (
                                  <span className='badge badge-light-success fs-8 fw-bold success_active'>
                                    Delivered
                                  </span>
                                )}
                                {val.status == 1 && (
                                  <span className='badge badge-light-warning fs-8 fw-bold warning_active'>
                                    Pending
                                  </span>
                                )}
                                {val.status == 2 && (
                                  <span className='badge badge-light-info fs-8 fw-bold'>
                                    Active
                                  </span>
                                )}
                                {val.status == 3 && (
                                  <span className='badge badge-light-danger fs-8 fw-bold danger_active'>
                                    Expired
                                  </span>
                                )}
                              </span>
                            </div>
                          </div>
                          <div className='timeline'>
                            {val.tracking_items?.map((item, ind) => {
                              return (
                                <>
                                  <div className='timeline-item align-items-center mb-7'>
                                    <div className='timeline-line w-40px mt-6 mb-n12' />
                                    <div className='timeline-icon' style={{ marginLeft: 11 }}>
                                      <i className='ki-duotone ki-cd fs-2 text-danger'>
                                        <span className='path1' />
                                        <span className='path2' />
                                      </i>
                                    </div>
                                    <div className='timeline-content m-0'>
                                      <div className='d-flex justify-content-between'>
                                        <span className='fs-6 text-gray-600 fw-semibold d-block'>
                                          {item.commitment_no}
                                        </span>
                                        <span className='fs-6 text-gray-800 fw-semibold d-block'>
                                          Qty: {item.qty}
                                        </span>
                                      </div>
                                      <span className='fs-8 fw-bold text-gray-800'>
                                        {item.deal}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            })}
                          </div>
                        </div>
                          </div>
                        {/* <div className='separator separator-dashed my-6' /> */}
                        </div>
                        
                      </>
                    )
                  })}
                  </div>
                </div>
              )}
            </div>
          </div>
          

        </div>
      </div>
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
